export const getErrorStyles = (hasError: boolean, theme: any) => ({
  backgroundColor: hasError ? theme.palette.error.fill : theme.palette.white.main,
  borderColor: hasError ? theme.palette.error.main : theme.palette.gray.light,
});
